module.exports = __webpack_public_path__ + "static/media/Macbook2.29c9819a.png";